import { createSelector } from "reselect";
import { createAssign } from "robodux";
import { put, select } from "saga-query";

import i18n from "@app/i18n";
import { thunks } from "@app/state/apis/api";
import { ECChooserPage } from "@app/state/insider/constants";
import { RootState } from "@app/state/rootState";

const t = i18n.t.bind(i18n);

export const categoryChooser = [
  {
    id: ECChooserPage.CONST_CCH_PANORAMIC,
    name: t("Panoramic"),
    parentId: null,
  },
  {
    id: ECChooserPage.CONST_CCH_REPORTS,
    name: t("Rapoarte"),
    parentId: null,
  },
  {
    id: ECChooserPage.CONST_CCH_INVOICING,
    name: t("Facturare"),
    parentId: null,
  },
  {
    id: ECChooserPage.CONST_CCHCH_PROFORMA,
    name: t("Proforme"),
    parentId: "Facturare",
  },
  {
    id: ECChooserPage.CONST_CCHCH_TRACKING,
    name: t("Urmarire"),
    parentId: "Facturare",
  },
  {
    id: ECChooserPage.CONST_CCHCH_FISCAL,
    name: "Fiscale",
    parentId: "Facturare",
  },
] as TChooserRepo[];

const CHOOSER_REPO = "insiderChooserRepo";
type TRegisteredChooserRepo = typeof categoryChooser;
export type TChooserRepoName = TRegisteredChooserRepo[number]["name"];

type TChooserRepo = {
  id: number;
  name: string;
  parentId: number | string;
};

export const chooserRepo = createAssign({
  name: CHOOSER_REPO,
  initialState: {
    currentPage: "Panoramic" as TChooserRepoName,
    currentChild: 5,
    items: categoryChooser,
  },
});

export const setUiInsidersDrawer = thunks.create<{ currentPage: number }>(
  "thunks/ui/drawer/setUiInsidersDrawer",
  function* (ctx, next) {
    const crtstate = yield* select(selectChooserRepo);
    const isChild =
      crtstate.items.find(
        (item: any) =>
          item.id === ctx.payload.currentPage && item.parentId !== null
      ) || null;

    if (isChild) {
      const parentId = crtstate.items.find(
        (item: any) => item.name === isChild.parentId
      ).id;
      console.log("parentId", parentId);
      yield* put(
        chooserRepo.actions.set({
          ...crtstate,
          currentPage: parentId,
          currentChild: ctx.payload.currentPage,
        })
      );
      yield* next();
      return;
    }
    yield* put(chooserRepo.actions.set({ ...crtstate, ...ctx.payload }));
    yield* next();
  }
);

export const selectChooserRepo = (state: RootState) => state[CHOOSER_REPO];

function createParameterSelector(selector: any) {
  return (_: unknown, params: any) => selector(params);
}

const getChildren = createParameterSelector(
  (params: any) => params?.parentId || null
);

export const selectChooserRepoItems = createSelector(
  selectChooserRepo,
  (chooserRepo) =>
    chooserRepo.items
      .filter((item: TChooserRepo) => item.parentId === null)
      .map((item: TChooserRepo) => ({
        ...item,
        children: chooserRepo.items.filter(
          (child: TChooserRepo) => child.parentId === item.name
        ),
      }))
);
export const selectChooserRepoCurrentPage = createSelector(
  selectChooserRepo,
  (chooserRepo) => chooserRepo.currentPage
);

export const selectChooserRepoChildrenItems = createSelector(
  selectChooserRepo,
  getChildren,
  (chooserRepo, parentId) => {
    return chooserRepo.items.filter(
      (item: TChooserRepo) => item.parentId === parentId
    );
  }
);

export const selectChooserRepoCurrentChild = createSelector(
  selectChooserRepo,
  (chooserRepo) => chooserRepo.currentChild
);
